<div class="rti-dealer-option-detail">
  <div class="rti-dealer-option-detail-content">
    <div class="rti-dealer-option-detail-content-retailprice">
      <label class="retailPrice"><span>$</span>{{model.retailPrice}}<span class="msrp">Installed Price</span></label>
    </div>
    <div class="rti-dealer-option-detail-content-image-section">
      <img [attr.src]="model.image.href" ddAppImageError/>
      <div class="rti-dealer-option-detail-content-description">
        <rti-html [value]="model.description"></rti-html>
      </div>
    </div>
  </div>
</div>
